var Error = /** @class */ (function () {
    function Error() {
    }
    Error.isCode = function (x) {
        return !!x && typeof x.code === 'string' && typeof x.message === 'string';
    };
    return Error;
}());
export { Error };
export var ModalType;
(function (ModalType) {
    ModalType.normal = 'normal';
    ModalType.error = 'error';
    ModalType.warn = 'warn';
    ModalType.prohibit = 'prohibit';
})(ModalType || (ModalType = {}));
//# sourceMappingURL=error.js.map